// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import MenuController from "./menu_controller"
application.register("menu-controller", MenuController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import SiteSetupController from "./site_setup_controller"
application.register("site-setup", SiteSetupController)
